import { createRoot } from "react-dom/client";
import App from "./App";
import { ConfirmationProvider } from "./sudokit/components/ConfirmationDialog/ConfirmationProvider";
import { ConfirmationRouter } from "./sudokit/components/ConfirmationDialog/ConfirmationRouter";

createRoot(document.getElementById("root")).render(
  <ConfirmationProvider>
    <ConfirmationRouter basename={process.env.REACT_APP_PUBLIC_URL}>
      <App />
    </ConfirmationRouter>
  </ConfirmationProvider>
);
